import DataContainer from 'Components/UI/DataContainer';
import { withStyles } from '@material-ui/core/styles';
// Empty styles are just to help with console errors due to prop validation
const FullScreenDataContainer = withStyles(() => ({
  root: {
    height: '100vh',
  },
}))(DataContainer);

export default FullScreenDataContainer;
